<div class="content ap-display-flex ap-align-items-center ap-text-align-center ap-margin-bottom-1">
    <div [innerHTML]="date() | relativeDate" class="ap-width-100" data-testid="date-divider-text"></div>
</div>
